import { render, staticRenderFns } from "./Rubros.vue?vue&type=template&id=214de1f8&scoped=true&"
import script from "./Rubros.vue?vue&type=script&lang=js&"
export * from "./Rubros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../bym/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214de1f8",
  null
  
)

export default component.exports